import { ICustomer } from "@app/common";

export interface CustomerFormValues extends Partial<ICustomer> { }

export const transformCustomerFormValuesToPayload = (customer?: Partial<ICustomer>): CustomerFormValues => {
  return {
    ...customer,
    birthday: customer?.birthday ? new Date(customer.birthday).toISOString() : undefined,
  };
};
